import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
  GetArticleResponseDTO,
  GetDailyFactResponseDTO,
  GetExercisesResponseDTO,
} from './doggyhub.dto';
@Injectable({ providedIn: 'root' })
export class DoggyhubService {
  constructor(private http: HttpClient) { }
  getExercises() {
    const url = environment.apiUrl + '/api/doggyhub/allexercises';
    return this.http.get<GetExercisesResponseDTO[]>(url);
  }

  getExerciseById(exerciseId: number) {
    const url = environment.apiUrl + '/api/doggyhub/exercise/' + exerciseId;
    return this.http.get<GetExercisesResponseDTO>(url);
  }

  getArticles(lastItemId: number) {
    const url = environment.apiUrl + '/api/doggyhub/articles/' + lastItemId;
    return this.http.get<GetArticleResponseDTO[]>(url);
  }
  getArticleById(articleId: number) {
    const url = environment.apiUrl + '/api/doggyhub/article/' + articleId;
    return this.http.get<GetArticleResponseDTO>(url);
  }
  getLatestFact() {
    const url = environment.apiUrl + '/api/doggyhub/fact/latest';
    return this.http.get<GetDailyFactResponseDTO>(url);
  }
  getFact(factId: number, isNext: boolean) {
    const url =
      environment.apiUrl + '/api/doggyhub/fact/' + factId + '/' + isNext;
    return this.http.get<GetDailyFactResponseDTO>(url);
  }
}
